import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import {
  AddOnType,
  IItemToRequest,
  MyPurchaseForm,
  OptionToPurchaseTableI,
} from 'src/app/shared/models/app-models';
import { AddOn } from 'src/app/shared/models/database-models';
import { MatSidenav } from '@angular/material/sidenav';
import {
  IAddItem,
  IItemPrice,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { deleteAddOnOptionFromMyPurchase } from 'src/app/core/store/form.actions';

@Component({
  selector: 'app-option-to-purchase',
  templateUrl: './option-to-purchase.component.html',
  styleUrls: ['./option-to-purchase.component.scss'],
})
export class OptionToPurchaseComponent implements OnInit, OnDestroy {
  @ViewChild('optionPurchaseAdd') optionPurchaseAdd!: MatSidenav;
  @Input() isReadOnly: boolean = false;
  @Input() prevTab: Function = () => { };
  store$: Observable<MyPurchaseForm>;
  destory$: Subject<boolean> = new Subject<boolean>();
  itemList: IItemToRequest[] = [];
  columnsToDisplay = [
    'index',
    'Description',
    'Quantity',
    'CurrencyCode',
    'EstimatedUnitPrice',
    'UnitOfMeasurements',
    'DurationYears',
    'DurationMonths',
  ];
  pageSizeOptions: number[] = [5, 10, 20];
  tableData: OptionToPurchaseTableI[] = [];
  dataSource = new MatTableDataSource<OptionToPurchaseTableI>(this.tableData);
  optionPurchaseEdit!: AddOn;
  optionPurchaseType: number = 1;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private store: Store<{
      form: MyPurchaseForm;
    }>,
    private router: Router
  ) {
    this.store$ = this.store.select('form');
  }

  async ngOnInit(): Promise<void> {
    this.store$
      .pipe(takeUntil(this.destory$))
      .subscribe((form: MyPurchaseForm) => {
        this.itemList = form.ItemList || [];
        this.customDataAddOn(this.itemList, form?.optionToPurchase || []);
      });
  }

  openDialog(record: any, rowIndex: number) {
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Discard item record?',
        contentMsg: 'This action cannot be undone.',
        btnNameOne: 'Discard',
        btnNameTwo: 'Cancel',
        click: () => {
          this.deleteItem(record);
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();

        },
      },
    });
  }
  deleteItem(record: any) {
    this.store.dispatch(
      deleteAddOnOptionFromMyPurchase({
        itemId: record.ItemAddOnId,
        actualIdx: record.actualIdx
      })
    );
  }
  customDataAddOn(itemList: IItemToRequest[], optionToPurchase: AddOn[]) {
    const addOnList: AddOn[] = [];
    const addItemList: IAddItem[] = [];
    const itemPriceList: IItemPrice[] = [];
    itemList.forEach((item, index) => {
      if (item.AddItems) {
        addItemList.push(item.AddItems);
      }
      if (item.ItemPrice) {
        itemPriceList.push(item.ItemPrice);
      }
      if (item.AddOnFeature) {
        const AddOnFeatureFilter = item.AddOnFeature.filter(
          (item) => item.AddOnTypeId == AddOnType.OptionToPurchase
        ).map((i) => ({ ...i, index: index + 1 }));
        addOnList.push(...AddOnFeatureFilter);
      }
    });
    const newAddOnList: AddOn[] = addOnList.map((addOnItem: AddOn) => {
      const findIndex = addItemList.findIndex((item) => {
        if (item.PurchaseItemId && addOnItem.PurchaseItemId) {
          return item.PurchaseItemId === addOnItem.PurchaseItemId;
        } else {
          return item.itemId === addOnItem.itemId;
        }
      });

      const foundItem = addItemList.find((item: IAddItem) => {
        if (item.PurchaseItemId && addOnItem.PurchaseItemId) {
          return item.PurchaseItemId === addOnItem.PurchaseItemId;
        } else {
          return item.itemId === addOnItem.itemId;
        }
      });
      const priceItem = itemPriceList[findIndex];
      return {
        ...addOnItem,
        Description: foundItem?.ItemDescription,
        CurrencyCode: priceItem.Currency.value,
        EstimatedUnitPrice: priceItem.UnitPrice,
        UnitOfMeasurements: priceItem.UnitOfMeasurement.value,
        itemId: foundItem?.itemId,
        displayItemNumber: foundItem?.displayItemNumber,
        index: addOnItem.index,
        isDeleted:false
      };
    });
    const newOptionToPurchase = [...newAddOnList, ...optionToPurchase];
    this.dataSource.data = newOptionToPurchase.map((i, idx) => ({
      ...i,
      index: i.index ? i.index : '-', // for displaying in the table
      rowIndex: idx, // index in the table
      totalRow: newOptionToPurchase.length, // total row use for calculate actual index in OTP array
    }));
  }

  navigateToItemVendor() {
    this.prevTab();
  }

  addNewOption() {
    this.optionPurchaseType = 1;
    this.optionPurchaseAdd.open();
  }

  editOption(row: AddOn, rowIndex: number) {
    this.optionPurchaseType = 2;
    this.optionPurchaseAdd.open();
    this.optionPurchaseEdit = { ...row, rowIndex };
  }

  ngOnDestroy(): void {
    this.destory$.next(true);
    this.destory$.unsubscribe();
  }

  navigateToAddItem(row: AddOn, rowIndex: number | null) {
    if (!row?.itemId) {
      this.editOption(row, rowIndex as number);
      return;
    }
    this.router.navigate([this.router.url.split(';')[0], 'edit', row.itemId], {
      queryParams: { tab: 3 },
    });
  }
}
